export default {
    whost: 'https://www.weibangong.com',
    mock: true, // 启用mock数据
}